import React from 'react';
import { Box, Skeleton, Theme, useMediaQuery } from '@mui/material';
import useScreenSize from '../../utils/useScreenSize';
import IsNewChip from '../cards/MuiCard/MuiCardBase/IsNewChip';
import { CoverImage } from '../cards/MuiCard/MuiCardBase/MuiCardBaseCover';

const SummaryCoverImage: React.FC<{
  isLoading: boolean;
  coverImage?: string;
  isNew?: boolean;
}> = ({ isLoading, coverImage, isNew }) => {
  const { isSmallScreen, isMediumScreen, isLargeScreen } = useScreenSize();
  const flexDirectionBreakPoint = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const getCoverImageHeight = () => {
    if (isLargeScreen) return 422;
    if (isMediumScreen) return 354;
    return 316;
  };

  const getCoverImageWidth = () => {
    if (isLargeScreen) return 298;
    if (isMediumScreen) return 250;
    return 224;
  };

  return (
    <Box
      sx={{
        minWidth: getCoverImageWidth(),
        maxWidth: getCoverImageWidth(),
        height: getCoverImageHeight(),
        position: 'relative',
        display: 'flex',
        marginRight: flexDirectionBreakPoint ? 'auto' : 0,
        marginLeft: flexDirectionBreakPoint ? 'auto' : 0,
        alignItems: flexDirectionBreakPoint ? 'center' : 'flex-start',
      }}
      data-testid='summary-cover-image-container'
    >
      {isLoading && <Skeleton height={`${getCoverImageHeight()}px`} />}
      {!isLoading && coverImage && (
        <CoverImage
          cover={coverImage}
          className='summary-cover-image'
          customSx={{
            ':hover': { boxShadow: 'none' },
            height: '100%',
          }}
        />
      )}
      {!isLoading && isNew && (
        <IsNewChip size={isSmallScreen ? 'small' : 'medium'} />
      )}
    </Box>
  );
};

export default SummaryCoverImage;
